import React, {useEffect, useMemo, useState} from 'react';
import {Button, Row, Col, Modal} from 'reactstrap';
import {Link} from 'react-router-dom';
import Moment from 'react-moment';
import ClaimStatus from '../Claim/ClaimStatus';
import {MaterialReactTable} from 'material-react-table';

const ModalExistingCustomers = (props) => {
  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (props.customers && props.customers.length > 0) {
      setModal(true);
    }
  }, [props.customers]);

  function toggleModal() {
    setModal(!modal);
    document.body.classList.add('no_padding');
  }

  const tableData = useMemo(() => {
    if (!props.customers) return [];
    return props.customers.map((c) => ({
      ...c,
      date_of_visit: c.date_of_visit ? (
        <Moment format="DD-MM-YYYY">{c.date_of_visit}</Moment>
      ) : '',
      status_label: (
        <ClaimStatus
          status={c.status}
          final_check_status={c.final_check_status}
          internal_check_status={c.internal_check_status}
        />
      ),
    }));
  }, [props.customers]);

  const columns = useMemo(
      () => [
        {accessorKey: 'name', header: 'Name'},
        {accessorKey: 'city', header: 'City'},
        {accessorKey: 'country', header: 'Country'},
      ],
      [],
  );

  return (
    <>
      <Modal
        size="lg"
        isOpen={modal}
        toggle={toggleModal}
        centered={true}
      >
        <div className="modal-body">
          <button
            type="button"
            onClick={() => setModal(false)}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <Row>
            <Col md={1}>
              <div className="avatar-sm">
                <span className="avatar-title rounded-circle bg-primary text-white">
                  <i className="bx bx-refresh bx-sm rotateInUpLeft" />
                </span>
              </div>
            </Col>

            <Col md={11}>
              <div className="mb-2">
                <h5 className="modal-title mt-0">We found similar Customer</h5>
                <p>Is this one of the customers you are looking for?</p>
              </div>

              <MaterialReactTable
                columns={columns}
                data={tableData}
                enablePagination={false}
                enableColumnFilters={false}
                enableSorting={false}
                enableTopToolbar={false}
                enableBottomToolbar={false}
                muiTablePaperProps={{elevation: 0}}
                muiTableContainerProps={{sx: {border: '1px solid #dee2e6'}}}
              />

              <div className="d-flex mt-4">
                <Button
                  onClick={() => setModal(false)}
                  className="btn btn-yellow mr-2"
                >
                  Add new Customer
                </Button>

                <Link to="/add-printer" className="btn btn-yellow mr-2">
                  Add new Printer
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
};

export default ModalExistingCustomers;
